export function hasAvailableTourBundleRooms(departure: App.Tours.TourV2OfferDeparture, roomCount: number): boolean {
  return !departure.ltleBundleId || (departure.ltleBundleAvailableRooms ?? 0) >= Math.max(1, roomCount)
}

export function getTourBundleRoomLimit(departure: App.Tours.TourV2OfferDeparture | undefined, maxRooms: number): number {
  return departure?.ltleBundleId ? Math.min(maxRooms, Math.max(0, departure.ltleBundleAvailableRooms ?? 0)) : maxRooms
}
